var map = {
	"./images/3d-avatar.png": "d289",
	"./images/404-bg.jpg": "68b4",
	"./images/404.png": "3dfc",
	"./images/Location.png": "db60",
	"./images/New2.png": "ec0d",
	"./images/Research.png": "8636",
	"./images/Secured Letter.png": "be53",
	"./images/WhatsApp.png": "91e2",
	"./images/arroq-left.png": "245c",
	"./images/avatar.png": "4d41",
	"./images/bubble-blue.png": "036b",
	"./images/bubble.png": "72ba",
	"./images/call.png": "0784",
	"./images/camera.png": "5e4f",
	"./images/chat-3d.png": "243e",
	"./images/checklist.png": "2149",
	"./images/clock.png": "fa24",
	"./images/closed-caht.png": "7366",
	"./images/dots.png": "fcb2",
	"./images/faq-2.png": "2e22",
	"./images/faq-null-icon.png": "bff4",
	"./images/graduation-hat.png": "9da5",
	"./images/hero-shape.jpg": "0fca",
	"./images/home.png": "28ea",
	"./images/img-loading.png": "a0c7",
	"./images/instagram.png": "cda7",
	"./images/logo-fill.png": "ac5e",
	"./images/logo.jpeg": "5c64",
	"./images/logo.png": "9d64",
	"./images/logo.webp": "fcb5",
	"./images/man.png": "d815",
	"./images/money-card.png": "c56f",
	"./images/new.png": "350c",
	"./images/notfound.png": "36a4",
	"./images/online-support.png": "9a5a",
	"./images/pattern.png": "1e4b",
	"./images/pay-check.png": "01f2",
	"./images/project-null-icon.png": "1e49",
	"./images/project.png": "807b",
	"./images/research-paper.png": "b0b8",
	"./images/school-album.png": "b011",
	"./images/slider-img5.jpg": "df4c",
	"./images/small-avatar-1.jpg": "58f2",
	"./images/small-img.jpg": "5f23",
	"./images/spaceship.png": "c985",
	"./images/steps-of-order.png": "32e4",
	"./images/student.png": "70ce",
	"./images/stupid.png": "a4ae",
	"./images/telephone.png": "812e",
	"./images/terms.png": "e9e0",
	"./images/ticket.png": "fa65",
	"./images/video.png": "c59e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";